import { AuthGuard } from '@nestjs/passport';

export class StoreJwtGuard extends AuthGuard('store-jwt') {}
